export const SET_AC_REPORT_LOADER = 'SET_AC_REPORT_LOADER';
export const FETCH_AC_CHARGERS_HISTORY_DATA = 'FETCH_AC_CHARGERS_HISTORY_DATA'
export const CLEAR_AC_CHARGING_HISTORY_LIST_DATA = 'CLEAR_AC_CHARGING_HISTORY_LIST_DATA'
export const SET_AC_CHARGING_HISTORY_LIST_TABLE_PROPS = 'SET_AC_CHARGING_HISTORY_LIST_TABLE_PROPS'
export const FETCH_AC_CHARGER_LOGS_DATA = 'FETCH_AC_CHARGER_LOGS_DATA'
export const SET_AC_CHARGER_LOGS_LIST_TABLE_PROPS = 'SET_AC_CHARGER_LOGS_LIST_TABLE_PROPS'
export const CLEAR_AC_CHARGER_LOGS_LIST_DATA = 'CLEAR_AC_CHARGER_LOGS_LIST_DATA'
export const FETCH_AC_EXCEPTION_LOGS_DATA = 'FETCH_AC_EXCEPTION_LOGS_DATA'
export const SET_AC_EXCEPTION_LOGS_LIST_TABLE_PROPS = 'SET_AC_EXCEPTION_LOGS_LIST_TABLE_PROPS'
export const CLEAR_AC_EXCEPTION_LOGS_LIST_DATA = 'CLEAR_AC_EXCEPTION_LOGS_LIST_DATA'

export const SET_AC_CHARGER_LOGS_LIST_REQUEST_HASH = 'SET_AC_CHARGER_LOGS_LIST_REQUEST_HASH'
export const SET_AC_CHARGING_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_AC_CHARGING_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION';

export const FETCH_AC_SESSION_HISTORY_DATA = 'FETCH_AC_SESSION_HISTORY_DATA'
export const CLEAR_AC_SESSION_HISTORY_LIST_DATA = 'CLEAR_AC_SESSION_HISTORY_LIST_DATA'
export const SET_AC_SESSION_HISTORY_LIST_TABLE_PROPS = 'SET_AC_SESSION_HISTORY_LIST_TABLE_PROPS'
export const SET_AC_SESSION_HISTORY_LIST_REQUEST_HASH = 'SET_AC_SESSION_HISTORY_LIST_REQUEST_HASH'
export const SET_AC_SESSION_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_AC_SESSION_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION';


export const FETCH_AC_STATUS_HISTORY_DATA = 'FETCH_AC_STATUS_HISTORY_DATA'
export const SET_AC_STATUS_HISTORY_LIST_REQUEST_HASH = 'SET_AC_STATUS_HISTORY_LIST_REQUEST_HASH'
export const SET_AC_STATUS_HISTORY_LIST_TABLE_PROPS = 'SET_AC_STATUS_HISTORY_LIST_TABLE_PROPS'
export const SET_AC_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_AC_STATUS_HISTORY_FILTERS_APPLIED_FROM_REDIRECTION'
export const CLEAR_AC_STATUS_HISTORY_LIST_DATA = 'CLEAR_AC_STATUS_HISTORY_LIST_DATA'